<template>
  <div class="company-navigation-wrapper">
    <ul class="company-navigation">
      <li>
        <router-link to="/shield/bios" class="section-link">bios</router-link>
      </li>
      <li>
        <router-link to="/shield/about-services" class="section-link"
          >about/services</router-link
        >
      </li>
      <li>
        <router-link to="/shield/contact" class="section-link"
          >contact/rfp</router-link
        >
      </li>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ShieldNavigation",
   watch: {
      '$route':{
        handler: (to) => {
          document.title = to.meta.title || 'Shield Maintenance'
        },
         immediate: true
      }
    } 
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.section-link {
  transition: all 0.4s;
}

.section-link:link,
.section-link:visited {
  color: #000;
}

.section-link:hover {
  color: #8a8a8a;
  text-decoration: underline;
}

.company-navigation-wrapper {
  position: relative;
}

.company-navigation {
  margin-top: 1em;
  padding: 1em 0 0 0;
  list-style: none;
  text-transform: uppercase;

  @media screen and (max-width: $medium-bp) {
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0em;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    text-align: left;
    // display: flex;
    // flex-direction: column;
    position: sticky;
    top: 0em;
    justify-content: center;
    border-left: 1px solid #000;
  }

  li {
    margin-left: 1em;
    margin-right: 1em;
  }
}
</style>
